import food from "../assets/food.jpg";
import technology from "../assets/technology.png";
import clothes from "../assets/clothes.jpg";
import pet from "../assets/pet.jpg";
export const homeScreenItems = [
  {
    id: 1,
    img: food,
    header: "food",
    text: "",
  },
  {
    id: 2,
    img: clothes,
    header: "clothes",
    text: "",
  },
  {
    id: 3,
    img: technology,
    header: "technology",
    text: "",
  },
  {
    id: 4,
    img: pet,
    header: "pet",
    text: "",
  },
];
